var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.343506,
    width: 30,
    height: 24,
    rx: 12,
    fill: "#FF5900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0454 3.7511C19.3753 4.10801 20.5879 4.80843 21.5615 5.78206C22.5352 6.7557 23.2356 7.9683 23.5925 9.29817",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2317 6.77954C18.0315 6.99196 18.761 7.41205 19.3462 7.99722C19.9313 8.5824 20.3514 9.31187 20.5639 10.1117",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4888 12.062C12.2956 13.7281 13.6428 15.0718 15.3109 15.8743C15.434 15.9326 15.5701 15.9578 15.7059 15.9475C15.8416 15.9372 15.9723 15.8917 16.0852 15.8155L18.5353 14.1789C18.6436 14.1054 18.7686 14.0606 18.8989 14.0486C19.0291 14.0367 19.1603 14.0578 19.2801 14.1103L23.8668 16.0802C24.0235 16.1454 24.1545 16.2604 24.2395 16.4073C24.3245 16.5543 24.3588 16.7252 24.3372 16.8936C24.1918 18.0282 23.638 19.071 22.7794 19.8269C21.9207 20.5827 20.8161 20.9997 19.6722 21C16.1372 21 12.747 19.5957 10.2474 17.0961C7.74777 14.5965 6.34351 11.2063 6.34351 7.67134C6.34376 6.52743 6.76082 5.4228 7.51665 4.56415C8.27247 3.70551 9.31527 3.15168 10.4499 3.00631C10.6183 2.98468 10.7892 3.01901 10.9362 3.10401C11.0831 3.18901 11.1981 3.31998 11.2633 3.47673L13.2332 8.07316C13.2845 8.19111 13.3059 8.31984 13.2956 8.44802C13.2854 8.5762 13.2438 8.6999 13.1744 8.8082L11.5378 11.2975C11.4649 11.4101 11.4221 11.5395 11.4136 11.6733C11.405 11.8072 11.4309 11.941 11.4888 12.062Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/callIcon.39999062ce363126e1b8d4e20151a63b.svg";
export { ForwardRef as ReactComponent };